import React from 'react';
import PropTypes from 'prop-types';
import '../../../styles/core.scss';
import AssignedClassesGroups from '../../assigned-classes-groups/index';

const AssignedClassFormatter = ({ dependentValues, value = [], handleOnAssignClass }) => (
    <AssignedClassesGroups
        assignedTo={value}
        dependentValues={dependentValues}
        handleOnAssignClass={handleOnAssignClass}
        showAssignButton />
);

AssignedClassFormatter.propTypes = {
    value: PropTypes.array,
    dependentValues: PropTypes.object,
    handleOnAssignClass: PropTypes.func
};

export default AssignedClassFormatter;



// WEBPACK FOOTER //
// ./app/components/formatters/assigned-class-formatter/index.js